import { DataService } from 'src/app/services/data.service';
import { BreadCrumb } from './../../../../interfaces/main';
import { Transaction } from '../../../../interfaces/transactions';
import { UserType } from 'src/app/interfaces/user';
import { User } from './../../../../interfaces/user';
import { AuthService } from './../../../../services/auth.service';
import { Lesson, Enrollment, Session } from './../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Payment } from 'src/app/interfaces/transactions';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { State } from 'src/app/interfaces/enums';

enum Tabs{
  Hidden = 0,
  Orders = 1,
  Enrollments = 2,
  Lessons = 3,
  Transactions = 4
}

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  UserType = UserType;
  Tabs = Tabs;
  State = State;

  currentTab: BehaviorSubject<Tabs>;

  enrollments: Enrollment[];
  _enrollments: Enrollment[];
  lessons: Lesson[];
  transactions: Transaction[];

  enrollmentTab = 'upcoming';

  payments: Payment[];

  user: User;

  currentLesson: string;
  currentSession: string;

  loadingCompletionSession = false;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'My Account',
    url: ['/profile']
  }]

  constructor(
    private toastr: ToastrService,
    private auth: AuthService,
    private router: Router,
    private data: DataService
  ) { }

  async ngOnInit() {
    this.user = await this.auth.getUser(true);

    this.breadcrumbs.push({
      link: this.user.name
    })

    switch(this.user.type){
      case UserType.Student: {
        this.currentTab = new BehaviorSubject(Tabs.Enrollments);
        break;
      }
      case UserType.Teacher: {
        this.currentTab = new BehaviorSubject(Tabs.Lessons);
        break;
      }
      default: {
        this.currentTab = new BehaviorSubject(Tabs.Hidden);
      }
    }

    this.currentTab.subscribe((v: Tabs) => {
      switch(v){
        case Tabs.Enrollments: {
          this.getEnrollmentsData();
          break;
        }
        case Tabs.Lessons: {
          this.getLessonsData();
          break;
        }
        case Tabs.Orders: {
          this.getPaymentsData();
          break;
        }
        case Tabs.Transactions: {
          this.getTransactionsData();
          break;
        }
      }
    })
  }

  async getTransactionsData(){
    this.data.getMyTransactions().subscribe((res) => {
      if(res && res.data){
        this.transactions = res.data;
      }
    });
  }

  async getLessonsData(){
    this.data.getLessons('', {teacher_id: this.user._id}).subscribe((res) => {
      if(res && res.data){
        this.lessons = res.data;
      }
    })
  }

  async getEnrollmentsData(lessonId?: string, sessionId?: string){
    try{
      this.enrollments = null;

      if(lessonId && sessionId){
        const res = await this.data.getEnrollments({lesson: lessonId, session: sessionId}).toPromise();

        if(res && res.data){
          this.enrollments = res.data;
        }
        return;
      }

      if(this.user.type === UserType.Student){
        const res = await this.data.getMyEnrollments().toPromise();

        if(res && res.data){
          for(let i = 0; i < res.data.length; i++){
            res.data[i].session = _.find((<Lesson>res.data[i].lesson).sessions, {_id: res.data[i].session}) as Session;
          }

          this._enrollments = res.data;

          this.filterStudentEnrollments();
        }
      }
    }catch(e){
      this.toastr.error(e.message);
    }
  }

  filterStudentEnrollments(){
    switch(this.enrollmentTab){
      case 'upcoming': {
        this.enrollments = _.filter(this._enrollments, v => v.state === State.Active);
        break;
      }
      case 'past': {
        this.enrollments = _.filter(this._enrollments, v => v.state !== State.Active);
        break;
      }
    }
  }

  async getPaymentsData(){
    this.data.getMyPayments().subscribe((res) => {
      if(res && res.data){
        this.payments = res.data;
      }
    })
  }

  logout(){
    this.auth.logout();
    this.router.navigate(['/']);
  }

  activateLesson(lesson: string, session: string){
    if(this.currentSession === session){
      this.currentSession = null;
    }else{
      this.currentSession = session;

      this.getEnrollmentsData(lesson, session);
    }
  }

 async checkSessionCompletion(session: Session, lesson: Lesson){
    try{
      this.loadingCompletionSession = true;

      this.data.checkSessionCompetion({
        meetingId: session.zoomId,
        courseId: lesson.course_id
      }).subscribe((res) => {
        if(res){
          this.data.completeLessonSession(lesson.course_id, lesson._id, session._id).subscribe((res) => {
            if(res){
              this.loadingCompletionSession = false;
              this.currentSession = null;
              this.currentLesson = null;
              this.getLessonsData();
              this.getEnrollmentsData(lesson._id, session._id);
            }
          })
        }
      })
    }catch(e){
      console.log(e);
      this.loadingCompletionSession = false;

      this.toastr.error(e.message);
    }
  }
}
